import { useAssertedParams } from '@korint/folio';
import { useSuspenseQuery } from '@tanstack/react-query';
import {
  type Asset,
  keyValueFieldsToObject,
  viewSpecificControllerListPolicyAssetsQueryOptions,
} from 'korint-sdk';

function getLatestAsset(data: Array<Asset<VehicleCustomFields>>) {
  return data?.sort(({ startedAt: start1 }, { startedAt: start2 }) => {
    const date1 = start1 ? new Date(start1).getTime() : 0;
    const date2 = start2 ? new Date(start2).getTime() : 0;

    return date2 - date1;
  })[0];
}

type VehicleCustomFields = {
  brand: string;
  model: string;
  fiscalPower: number;
  latestPriceInEuro: number;
  numberOfSeats: string;
  energy: string;
  vehicleFirstRegistrationDate: string;
  vehicleMileage: number;
  vehicleSaleDate: string;
  vehicleDeliveryDate: string;
  registrationNumber: string;
  unladenWeight: number;
  version: string;
  transmission: string;
};

export function useGetPolicyAsset() {
  const { policyId, branchId } = useAssertedParams();

  return useSuspenseQuery({
    ...viewSpecificControllerListPolicyAssetsQueryOptions(policyId, {
      branchId,
    }),
    refetchOnMount: 'always',
    select: data => {
      return getLatestAsset(
        data.data.map(asset => ({
          ...asset,
          customFields: keyValueFieldsToObject<VehicleCustomFields>(asset.customFields ?? []),
        })),
      );
    },
  });
}
